"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysModel = void 0;
const core_1 = require("@veeam/core");
const core_2 = require("../../../core");
class DaysModel extends core_1.Model {
    constructor(selectedDays) {
        super(DaysModel.getModelValueFromSelectedDays(selectedDays));
    }
    static getModelValueFromSelectedDays(selectedDays) {
        return selectedDays.reduce((modelValue, dayOfWeek) => {
            const newValue = DaysModel.dayOfWeekToModelValueMap.get(dayOfWeek);
            return Object.assign(Object.assign({}, modelValue), newValue);
        }, {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        });
    }
    static getSelectedDaysFromModelValue(modelValue) {
        return Object.keys(modelValue).reduce((dayOfWeekList, day) => {
            if (!modelValue[day]) {
                return dayOfWeekList;
            }
            const newValue = DaysModel.modelValueToDayOfWeekMap.get(day);
            if (newValue) {
                return [...dayOfWeekList, newValue];
            }
            return dayOfWeekList;
        }, []);
    }
}
exports.DaysModel = DaysModel;
DaysModel.dayOfWeekToModelValueMap = new Map([
    [core_2.DAY_OF_WEEK.monday, { monday: true }],
    [core_2.DAY_OF_WEEK.tuesday, { tuesday: true }],
    [core_2.DAY_OF_WEEK.wednesday, { wednesday: true }],
    [core_2.DAY_OF_WEEK.thursday, { thursday: true }],
    [core_2.DAY_OF_WEEK.friday, { friday: true }],
    [core_2.DAY_OF_WEEK.saturday, { saturday: true }],
    [core_2.DAY_OF_WEEK.sunday, { sunday: true }],
]);
DaysModel.modelValueToDayOfWeekMap = new Map([
    ['monday', core_2.DAY_OF_WEEK.monday],
    ['tuesday', core_2.DAY_OF_WEEK.tuesday],
    ['wednesday', core_2.DAY_OF_WEEK.wednesday],
    ['thursday', core_2.DAY_OF_WEEK.thursday],
    ['friday', core_2.DAY_OF_WEEK.friday],
    ['saturday', core_2.DAY_OF_WEEK.saturday],
    ['sunday', core_2.DAY_OF_WEEK.sunday],
]);
//# sourceMappingURL=DaysModel.js.map